import script from "./mapa-interativo.vue?vue&type=script&setup=true&lang=js"
export * from "./mapa-interativo.vue?vue&type=script&setup=true&lang=js"

import "./mapa-interativo.vue?vue&type=style&index=0&id=d542b31e&lang=css"

const __exports__ = script;

export default __exports__